// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const ActionUndo = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M7.392 7.467h7.875a4.766 4.766 0 014.766 4.766A4.764 4.764 0 0115.267 17H5.3v-1.733h9.967a3.033 3.033 0 100-6.067H7.392l1.95 1.95-1.225 1.226-4.043-4.043 4.043-4.042 1.225 1.226-1.95 1.95z" />
  </svg>
);

export default ActionUndo;
